class Payment {
    showPaymentBlock(priceBoxEl, price) {
        const paymentBlock = new PaymentBlock(priceBoxEl, price);
        paymentBlock.fillWithInfo();
        paymentBlock.show();

        return paymentBlock;
    }
}


class StandardPayment extends Payment {

    constructor(priceBoxEl) {
        super();
        
        this.showPaymentBlock(priceBoxEl, priceBoxEl.data('price'));
    }
}

class AmountPayment extends Payment {

    constructor(priceBoxEl) {
        super();

        const amountBoxes = new PaymentAmountBoxes(this);
        amountBoxes.setup(priceBoxEl);
    }

}